import { Filter } from './badwords'

const COMMENT_SKIP = ['dick', 'wang', 'hells']

const filter = new Filter({ splitRegex: /\b/ })
filter.removeWords(...COMMENT_SKIP)

export function maskProfanity(text: string): string {
  if (!text || !filter.isProfane(text)) {
    return text
  }
  return filter.clean(text)
}
